<template>
    <div class="install">
        <div class="install__dialog">
            <h1 class="install__dialog__header">Einrichtung</h1>
            <div class="install__dialog__body">
                <p class="install__dialog__instructions">
                  Zum Einrichten gehe auf: <strong>{{ url }}/activate</strong>
                </p>
                <h1 class="install__dialog__machineid">{{ machineId }}</h1>
                <h3 class="install__dialog__seperator">ODER</h3>
                <qr-code :text="`${url}/activate?id=${machineId}`"></qr-code>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import QrCode from 'vue-qrcode-component';

export default {
  name: 'InstallDialog',
  components: {
    QrCode,
  },
  data() {
    return {
      url: process.env.VUE_APP_CMS_URL,
      machineId: global.machineId,
    };
  },
};
</script>

<style lang="scss">
    .install {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        position: absolute;
        &__dialog {
            border-radius: 4px;
            box-shadow: 0 5px 15px rgba(162, 45, 45, 0.25), 0 5px 10px rgba(248, 87, 166, 0.15);
            padding: 5px;
            background: linear-gradient(to right, #f857a6, #ff5858);
            &__body {
                padding: 2.5em 5em;
                background: #fff;
                border-radius: 4px;
            }
            &__header {
                margin: 0 0;
                padding: 2.5rem;
                color: #fff;
                font-weight: 100;
                text-align: center;
                font-size: 3em;
            }
            &__machineid {
                text-align: center;
                font-size: 4em;
                font-weight: 100;
                background: #f7f7f7;
                border-radius: 4px;
                border: solid 0.025em #eee;
            }
            &__seperator {
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #444;
                &:before, &:after {
                    content: '';
                    display: block;
                    width: 5em;
                    height: 1px;
                    background: #ccc;
                    margin: 0 1em;
                }
            }
            img {
                margin: auto;
            }
        }
    }
</style>
